<template>
  <div>
    <b-modal
      id="modalFacture"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="xl"
      :title="titleModal"
    >
      <template #default>
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
          <div class="row" v-if="mode !== 'create' && form.document">
            <div class="col-md-12">
              <table
                class="card table table-sm table-custom-primary table-bordered mb-0"
              >
                <tbody>
                  <tr class="d-flex font-size-17 font-weight-bold">
                    <td class="col-12 text-custom-primary text-center">
                      Référence facture : {{ form.document.document.reference }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-4">
              <div class="form-group">
                <label for="date"
                  >Date <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.date"
                  name="date"
                  placeholder="Date"
                  :disabled="mode === 'show'"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('date'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="date"></has-error>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n2 mt-md-0">
              <div class="form-group">
                <label for="date_echeance"
                  >Date d'échéance <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="form.date_echeance"
                  name="date_echeance"
                  placeholder="Date d'échéance"
                  :disabled="mode === 'show'"
                  lang="fr"
                  format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY"
                ></date-picker>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('date_echeance'),
                  }"
                  type="hidden"
                />
                <has-error :form="form" field="date_echeance"></has-error>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n2 mt-md-0">
              <div class="form-group">
                <label for="planning_abonnement"
                  >Période <span class="text-danger">*</span></label
                >
                <v-custom-select
                  :disabled="mode === 'show'"
                  label="id"
                  :options="periodes"
                  :reduce="(periode) => periode.uuid"
                  v-model="form.planning_abonnement"
                  placeholder="Période"
                  @input="onChangePeriode"
                >
                  <template slot="selected-option" slot-scope="option">
                    {{ option.periode | formatDate('DD/MM/YYYY') }}
                  </template>
                  <template v-slot:option="{ periode, montant_prevu }">
                    <h5 style="margin: 0">
                      {{ periode | formatDate('DD/MM/YYYY') }}
                    </h5>
                    <span class="d-block">
                      Montant prévu :
                      {{
                        formatWithCurrency(
                          montant_prevu,
                          currentAbonnement.devise.symbole
                        )
                      }}
                    </span>
                  </template>
                  <template #no-options> Aucune donnée </template>
                  <template #search="{ attributes, events }">
                    <input
                      id="planning_abonnement"
                      class="custom-select-height vs__search"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-custom-select>
                <div>
                  <input
                    type="hidden"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('planning_abonnement'),
                    }"
                  />
                  <has-error
                    :form="form"
                    field="planning_abonnement"
                  ></has-error>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n2">
              <div class="form-group">
                <label for="num_facture">N° facture </label>
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('num_facture'),
                  }"
                  id="num_facture"
                  v-model="form.num_facture"
                  type="text"
                  placeholder="N° facture"
                  :required="mode !== 'show'"
                  :disabled="mode === 'show'"
                />
                <has-error :form="form" field="num_facture"></has-error>
              </div>
            </div>

            <div class="col-md-6 col-lg-4 mt-n2">
              <div class="form-group">
                <label for="montant"
                  >Montant ({{ currentAbonnement.devise.symbole }})
                  <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('montant'),
                  }"
                  id="budget_montant"
                  v-model="form.montant"
                  type="text"
                  placeholder="Montant"
                  :required="mode !== 'show'"
                  :disabled="mode === 'show'"
                  @focus="$event.target.select()"
                />
                <has-error :form="form" field="montant"></has-error>
              </div>
            </div>

            <div
              class="col-md-6 col-lg-4 mt-n2"
              v-if="
                currentAbonnement.devise.uuid !== getCurrency().uuid &&
                currentAbonnement.devise.uuid !== null
              "
            >
              <div class="form-group">
                <label for="taux"
                  >Taux de change
                  <span>
                    ({{
                      currentAbonnement.devise.symbole +
                      ' -> ' +
                      getCurrency().symbole
                    }})
                  </span>
                  <span class="text-danger">*</span></label
                >
                <input
                  class="form-control"
                  :class="{
                    'is-invalid': form.errors.has('taux'),
                  }"
                  :disabled="mode === 'show'"
                  id="taux"
                  v-model="form.taux"
                  type="text"
                  placeholder="Taux de change"
                />
                <has-error :form="form" field="taux"></has-error>
              </div>
            </div>

            <div class="col-md-12 col-lg-6 mt-n2">
              <div class="form-group">
                <div class="form-group">
                  <label for="commentaire"
                    >Commentaire (max : 100 caractères )
                  </label>
                  <textarea
                    v-model="form.commentaire"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('commentaire'),
                    }"
                    rows="5"
                    maxlength="100"
                    :disabled="mode === 'show'"
                  ></textarea>
                  <has-error :form="form" field="commentaire"></has-error>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template #modal-footer>
        <button
          type="button"
          class="btn btn-danger mr-2"
          @click="$bvModal.hide('modalFacture')"
        >
          Fermer
        </button>

        <button
          v-if="mode !== 'show'"
          type="submit"
          class="btn btn-custom-primary w-40"
          @click="submit"
          style="min-width: 100px"
        >
          {{ mode === 'create' ? 'Ajouter' : 'Enregistrer' }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Form from 'vform';
import URL from '@/http/achat/abonnement/facture';
import DatePicker from 'vue2-datepicker';
export default {
  data() {
    return {
      form: new Form({
        planning_abonnement: null,
        num_facture: null,
        date: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        date_echeance: null,
        montant: null,
        commentaire: null,
        devise: null,
        taux: 1,
      }),
      periodes: [],
      mode: 'create',
      titleModal: 'Ajout de nouvelle facture',
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    montantConvertit() {
      return this.form.montant * this.form.taux;
    },
  },
  methods: {
    onChangePeriode() {
      let currentPeriode = window._.find(
        this.periodes,
        (p) => p.uuid === this.form.planning_abonnement
      );
      if (currentPeriode) this.form.montant = currentPeriode.montant_prevu;
    },
    async newModal() {
      this.customErrorMessage = null;
      this.form.reset();
      this.form.clear();
      this.$bvModal.show('modalFacture');
      this.mode = 'create';
      this.periodes = [];

      this.form.devise = this.currentAbonnement.devise.uuid;

      await window.axios
        .get(URL.GET_REQUIREMENTS + '/' + this.currentAbonnement.id)
        .then((resp) => {
          this.periodes = resp.data.periodes;
        })
        .catch();

      await this.$bvModal.show('modalFacture');
    },

    async showModal(id) {
      this.customErrorMessage = null;
      this.form.reset();
      this.form.clear();
      this.titleModal = "Aperçu d'une facture";
      this.mode = 'show';
      this.periodes = [];

      this.form.devise = this.currentAbonnement.devise.uuid;

      await window.axios
        .all([
          window.axios.get(URL.FACTURE + '/' + id),
          window.axios.get(
            URL.GET_REQUIREMENTS + '/' + this.currentAbonnement.id
          ),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            Object.assign(this.form, resp1.data.facture_abonnement);
            delete this.form.periode;
            this.periodes = resp2.data.periodes;
          })
        )
        .catch();

      await this.$bvModal.show('modalFacture');
    },
    async editModal(id) {
      this.customErrorMessage = null;
      this.form.reset();
      this.form.clear();
      this.titleModal = "Modification d'une facture";
      this.mode = 'edit';
      this.periodes = [];

      this.form.devise = this.currentAbonnement.devise.uuid;

      await window.axios
        .all([
          window.axios.get(URL.FACTURE + '/' + id),
          window.axios.get(
            URL.GET_REQUIREMENTS + '/' + this.currentAbonnement.id
          ),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            Object.assign(this.form, resp1.data.facture_abonnement);
            delete this.form.periode;
            this.periodes = resp2.data.periodes;
          })
        )
        .catch();

      await this.$bvModal.show('modalFacture');
    },
    submit() {
      this.customErrorMessage = null;
      this.$bvModal.hide('modalFacture');

      if (this.form.id) {
        //update
        this.form
          .put(URL.FACTURE + '/' + this.form.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.form.reset();
            this.form.clear();
            this.$emit('onRefreshTable');
          })
          .catch((err) => {
            window._.forEach(err.response.data.errors, (value, key) => {
              if (key.includes('custom')) {
                this.customErrorMessage = value[0];
              }
              return 0;
            });
            this.$bvModal.show('modalFacture');
          });
      } else {
        //store
        this.form
          .post(URL.FACTURE)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.form.reset();
            this.form.clear();
            this.$emit('onRefreshTable');
          })
          .catch((err) => {
            window._.forEach(err.response.data.errors, (value, key) => {
              if (key.includes('custom')) {
                this.customErrorMessage = value[0];
              }
              return 0;
            });
            this.$bvModal.show('modalFacture');
          });
      }
    },
  },
  props: ['currentAbonnement'],
};
</script>

<style scoped lang="scss"></style>
